// translate
import i18next from 'i18next';
const t = i18next.t;

// ===============================|| Fetch Data ||=============================== //

export const FetchData = (data, setStatus = () => {}, setErrors = () => {}) => {
    // Reset Status & Error
    setStatus({ success: false });
    setErrors({ submit: false });

    if (!data.success) {
        if (process.env.NODE_ENV === 'development') console.log(data);
        SetError(data, setStatus, setErrors);

        return false;
    } else {
        setStatus({ success: true });
        return data.data;
    }
};

export const SetError = (error, setStatus = () => {}, setErrors = () => {}) => {
    setStatus({ success: false });
    setErrors({ submit: GetValidationError(error) || t(error.message) });

    switch (error.status) {
        case 401:
        case 403:
            const curUrl = location.href;
            if (curUrl.indexOf('login') < 0 && curUrl.split('#')[1]?.length > 1) location.href = '/';
            break;

        default:
            break;
    }

    return false;
};

export const GetValidationError = (error) => {
    const errors = error?.data?.errors;
    if (!errors || Object.keys(errors).length <= 0) return '';

    let ret = '';
    for (const val of Object.values(errors)) {
        val.forEach((v) => {
            const m = v
                ?.split(':')
                ?.map((m) => t(m.trim()))
                ?.join(': ');
            ret += `\n ${t(m)}`;
        });
    }
    return ret;
};

export default FetchData;
